import React from "react";
import inflection from "inflection";
import moment from "moment";

import Table from "jazasoft/lib/mui/components/Table";
import { LicenseType } from "../../constants";
import { humanizeNumber } from "../../utils/helpers";

export const renderEntitlements = record =>
  record.entitlements
    ? JSON.parse(record.entitlements)
        .map(
          e =>
            `${inflection.humanize(e.entitlementType)} - ${humanizeNumber(e.entitlementValue)} ${
              e.unit ? `${e.unit}${e.entitlementValue !== 1 ? "s" : ""}` : ""
            }`
        )
        .join(", ")
    : "-";

const ColumnInfo = ({ record }) => {
  let value = "";
  let values = [];
  if (record.event === "License Purchased") {
    const data = JSON.parse(record.data);
    values.push(`License Type: ${data.licenseType}`);
    values.push(`License Flavour: ${data.licenseFlavour}`);
    if (data.licenseType === LicenseType.PERPETUAL) {
      values.push(`AMC Validity: ${data.amcValidity} days`);
    } else {
      values.push(`Subscription Validity: ${data.subscriptionValidity} days`);
    }
    values.push(renderEntitlements(data));
  } else if (record.event === "License Renewed") {
    const data = JSON.parse(record.data);
    if (data.licenseType === LicenseType.PERPETUAL) {
      values.push(
        `AMC Validity: ${data.amcValidity} days (${moment(data.lastRenewedOn).format("ll")} - ${moment(
          data.lastRenewedOn
        )
          .add(data.amcValidity, "days")
          .format("ll")})`
      );
    } else {
      values.push(
        `Subscription Validity: ${data.subscriptionValidity} days (${moment(data.lastRenewedOn).format(
          "ll"
        )} - ${moment(data.lastRenewedOn).add(data.subscriptionValidity, "days").format("ll")})`
      );
    }
  } else if (record.event === "License Upgraded") {
    const prevData = record.prevData ? JSON.parse(record.prevData) : {};
    const data = record.data ? JSON.parse(record.data) : {};
    if (prevData.licenseType !== data.licenseType) {
      values.push(`License Type: ${prevData.licenseType} --> ${data.licenseType}`);
    }
    if (prevData.licenseFlavour !== data.licenseFlavour) {
      values.push(`License Flavour: ${prevData.licenseFlavour} --> ${data.licenseFlavour}`);
    }
    if (prevData.entitlements !== data.entitlements) {
      const prevList = JSON.parse(prevData.entitlements);
      const list = JSON.parse(data.entitlements);

      prevList.forEach(entitlement => {
        const newEntitlement = list.find(e => e.entitlementType === entitlement.entitlementType);
        if (newEntitlement && newEntitlement.entitlementValue !== entitlement.entitlementValue) {
          values.push(
            `${inflection.humanize(entitlement.entitlementType)}: ${humanizeNumber(entitlement.entitlementValue)} ${
              entitlement.unit ? `${entitlement.unit}s` : ""
            } --> ${humanizeNumber(newEntitlement.entitlementValue)} ${entitlement.unit ? `${entitlement.unit}s` : ""}`
          );
        }
      });
    }
  }
  value = values.join(", ");
  return <span>{value}</span>;
};

const columns = [
  { dataKey: "date", title: "Date" },
  { dataKey: "event", title: "Event" },
  { dataKey: "info", title: "Details", element: <ColumnInfo /> }
];

const LicenseHistory = ({ record = {} }) => {
  const rows = record.licenseHistoryList
    ? record.licenseHistoryList
        .sort((a, b) => b.createdAt - a.createdAt)
        .map(e => ({
          ...e,
          date: moment(e.createdAt).format("ll")
        }))
    : [];
  return (
    <div>
      <Table columns={columns} rows={rows} />
    </div>
  );
};

export default LicenseHistory;
